import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-square-box',
  templateUrl: './square-box.component.html',
  styleUrls: ['./square-box.component.scss']
})
export class SquareBoxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
